<ul class="breadcrumb">
  <li *ngFor="let item of menuItems; index as i; first as isFirst; last as isLast">
    <a [ngClass]='{"active": !isLast}' [routerLink]="item.url">
      {{ 'routes.' + item.label | translate }} <span *ngIf="item.title">( {{item.title}} )</span>
    </a>
  </li>
</ul>
